import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withLoader from 'components/Shared/withLoader';

import LigneGestionQualification from './LigneGestionQualification';

import { AnomalieType } from 'constants.js';
import { reclamationSoumiseQuantiteRetournable } from 'utils/quantiteRetournableHelper';
import { getPieceSelectionnee, estPieceRapido } from 'utils/depotHelper';

const LigneGestionQualificationWithLoader = withLoader(LigneGestionQualification);

const initialState = {
    editedRowNumber: -1,
    ligneQualification: {
        codeArticleAnomalie: '',
        quantiteAnomalie: '',
        commentaireAnomalie: '',
        descriptifAnomalie: ''
    }
};

class LigneGestionQualificationContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = initialState;
    }

    initializeState(editedRowNumber) {
        this.setState({
            ...initialState,
            editedRowNumber: editedRowNumber
        });
    }

    handleStartEditing = (event, numeroLigne) => {
        // Initialisation de la saisie.
        const { reclamation } = this.props;

        let ligneQualification = reclamation.lignes.find(l => l.numeroLigne === numeroLigne);

        if (ligneQualification) {
            this.setState({
                editedRowNumber: numeroLigne,
                ligneQualification: {
                    codeArticleAnomalie: ligneQualification.codeArticleAnomalie,
                    descriptifAnomalie: ligneQualification.descriptifAnomalie,
                    quantiteAnomalie: ligneQualification.quantiteAnomalie,
                    commentaireAnomalie: ligneQualification.commentaireAnomalie
                }
            });
        } else {
            this.initializeState(numeroLigne);
        }
    }

    handleCancelEditing = () => {
        // On annule la saisie en cours.
        this.initializeState(-1);
    }

    handleDeleteEditing = () => {
        // On supprime la saisie en cours.
        const { editedRowNumber } = this.state;
        const { onRemoveLigne } = this.props;

        onRemoveLigne(editedRowNumber);

        this.initializeState(-1);
    }

    handleDoneEditing = () => {
        // On ajoute la saisie.
        const { onAddLigne, onRemoveLigne, typeAnomalie, pieceGestionLignes } = this.props;
        const { editedRowNumber, ligneQualification } = this.state;

        let ligne = pieceGestionLignes.find(x => x.numeroLigne === editedRowNumber);

        console.log("handleDoneEditing", { editedRowNumber, typeAnomalie, ligneQualification, ligne });

        if (   ligneQualification.quantiteAnomalie === "0"
            && (typeAnomalie === AnomalieType.DemandeRetour || typeAnomalie === AnomalieType.DemandeRetourVolontaire))
        {
            // Les lignes en quantité à 0 (zéro) sont supprimées des retours
            onRemoveLigne(editedRowNumber);
        }
        else
        {
            let result = {
                numeroLigne: editedRowNumber,
                typeAnomalie: typeAnomalie,
                codeArticle: ligne.codeArticle,
                codeArticleAnomalie: ligneQualification.codeArticleAnomalie,
                descriptifAnomalie: ligneQualification.descriptifAnomalie,
                quantiteAnomalie: ligneQualification.quantiteAnomalie,
                commentaireAnomalie: ligneQualification.commentaireAnomalie,
                marqueExclusive: ligne.marqueExclusive,
                autoriseSAVPlateformeLogistique: ligne.fournisseur ? ligne.fournisseur.autoriseSAVPlateformeLogistique : false,
                poids: ligne.poids,
                fournisseur: ligne.fournisseur,
                prixUnitaire: ligne.prixUnitaire,
                valeurUnitaire: ligne.valeurUnitaire,

                quantiteCommandee: ligne.quantiteCommandee,
                quantiteLivree: ligne.quantiteLivree,
                quantiteEnCoursDossier: ligne.quantiteEnCoursDossier,
                quantiteRetournable: ligne.quantiteRetournable,
            };

            onAddLigne(result);
        }


        // On réinitialise la saisie.
        this.initializeState(-1);
    }

    handleChange = event => {
        let ligneQualification = { ...this.state.ligneQualification };
        ligneQualification[event.target.name] = event.target.value;

        this.setState({
            ligneQualification
        });
    };

    handleChangeQuantiteAnomalie = event => {
        let ligneQualification = { ...this.state.ligneQualification };
        ligneQualification.quantiteAnomalie = event.target.value;

        this.setState({
            ligneQualification
        });
    };

    render() {
        const {
            reclamation,
            pieceGestionLignes,
            typeAnomalie,
            disabled,
            disableCompose,
            rapido,
            isLoading,
            quantiteLibre,
            afficherQuantiteRetournable,
            capperSaisie
        } = this.props;

        const { editedRowNumber, ligneQualification } = this.state;

        // DEV-4540 : types Cession / Interne jamais soumis à la quantité retournable,
        // quelle que soit la qualification (ni colonnes, ni plafonnement de saisie).
        const soumisQuantiteRetournable = reclamationSoumiseQuantiteRetournable(reclamation);

        // DEV-4648 : la restriction « saisie autorisée uniquement sur les composants » (KitType = 0
        // exclu) n'a de sens que sur les pièces Rapido (dépôt 15), où le composé est identifié par
        // KitRapido / NOGRP (DEV-4301). Hors dépôt 15 (BONWEB / BONFOUPHY), le composé reste saisissable.
        const disableComposeEffectif = (disableCompose ?? false) && rapido;

        return (
            <LigneGestionQualificationWithLoader
                isLoading={isLoading}
                reclamation={reclamation}
                ligneQualification={ligneQualification}
                pieceGestionLignes={pieceGestionLignes}
                onChange={this.handleChange}
                onChangeQuantiteAnomalie={this.handleChangeQuantiteAnomalie}
                typeAnomalie={typeAnomalie}
                disabled={disabled}
                disableCompose={disableComposeEffectif}
                editedRowNumber={editedRowNumber}
                onStartEditing={this.handleStartEditing}
                onCancelEditing={this.handleCancelEditing}
                onDeleteEditing={this.handleDeleteEditing}
                onDoneEditing={this.handleDoneEditing}
                quantiteLibre={quantiteLibre ?? false}
                afficherQuantiteRetournable={soumisQuantiteRetournable && (afficherQuantiteRetournable ?? false)}
                capperSaisie={soumisQuantiteRetournable && (capperSaisie ?? afficherQuantiteRetournable ?? false)}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    pieceGestionLignes: state.pieceGestionLigne.pieceGestionLignes.items,
    isLoading: state.pieceGestionLigne.pieceGestionLignes.isLoading,
    rapido: estPieceRapido(getPieceSelectionnee(state, ownProps.namespace, ownProps.reclamation))
});

LigneGestionQualificationContainer.propTypes = {
    reclamation: PropTypes.object.isRequired,
    onAddLigne: PropTypes.func.isRequired,
    onRemoveLigne: PropTypes.func.isRequired,
    typeAnomalie: PropTypes.number.isRequired,
    disabled: PropTypes.bool,
    disableCompose: PropTypes.bool,
    namespace: PropTypes.string,
    // DEV-4012 : affiche les colonnes qté commandée / livrée / en cours / retournable.
    afficherQuantiteRetournable: PropTypes.bool,
    // DEV-4347 : plafonne la saisie à la quantité retournable (découplé de l'affichage).
    // Par défaut = afficherQuantiteRetournable ; un step peut le forcer à false (ex. cas surplus non soumis).
    capperSaisie: PropTypes.bool,
};


export default connect(mapStateToProps, null)(LigneGestionQualificationContainer);
